<template>
  <div class="filter-set showings">
    <div class="filter-name">
      <span class="filter-name__label">Seuraava esittely</span>
      <i class="toggle-expander icon-chevron-down"></i>
    </div>
    <expander :expanded="expanderVisible">
      <RadioButtonGroup
        v-model="selectedShowingsModel"
        :options="[
          { value: String(showings.all), label: 'Näytä kaikki' },
          { value: String(showings.near), label: 'Esittely 3 vrk sisällä' },
          { value: String(showings.far), label: 'Esittely 7 vrk sisällä' },
        ]"
        name="next-showing"
        ariaLabel="seuraava esittely"
      />
    </expander>
  </div>
</template>

<script lang="ts">
import Expander from '../expander/expander.vue';
import config from '@/config';
import searchUtils from '@/app/utils/search-utils';
import RadioButtonGroup from '@/app/components/form/radiobutton-group.vue';

export default {
  name: 'showings',
  data: () => ({
    showings: config.SHOWINGS,
  }),
  props: {
    expanderVisible: {
      type: Boolean,
      default: undefined, // By default, the expander is visible but without any complex close/open css logic
    },
    selectedShowingIn: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    selectedShowingsModel: {
      get() {
        return this.selectedShowingIn ? String(this.selectedShowingIn) : String(this.showings.all);
      },
      set(value: string) {
        let updates = { showingIn: 0 as number | undefined };
        if (value !== String(this.showings.all)) {
          updates = { showingIn: Number(value) };
        }
        searchUtils.addFilterToUrl(this.$router, this.$route, updates);
      },
    },
  },
  mounted() {},
  components: {
    Expander,
    RadioButtonGroup,
  },
};
</script>
